var map = {
	"./404.svg": "./src/assets/icons/svg/404.svg",
	"./bug.svg": "./src/assets/icons/svg/bug.svg",
	"./build.svg": "./src/assets/icons/svg/build.svg",
	"./chart.svg": "./src/assets/icons/svg/chart.svg",
	"./clipboard.svg": "./src/assets/icons/svg/clipboard.svg",
	"./code.svg": "./src/assets/icons/svg/code.svg",
	"./component.svg": "./src/assets/icons/svg/component.svg",
	"./dashboard.svg": "./src/assets/icons/svg/dashboard.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./dict.svg": "./src/assets/icons/svg/dict.svg",
	"./documentation.svg": "./src/assets/icons/svg/documentation.svg",
	"./download.svg": "./src/assets/icons/svg/download.svg",
	"./drag.svg": "./src/assets/icons/svg/drag.svg",
	"./druid.svg": "./src/assets/icons/svg/druid.svg",
	"./edit.svg": "./src/assets/icons/svg/edit.svg",
	"./education.svg": "./src/assets/icons/svg/education.svg",
	"./email.svg": "./src/assets/icons/svg/email.svg",
	"./example.svg": "./src/assets/icons/svg/example.svg",
	"./excel.svg": "./src/assets/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/assets/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/assets/icons/svg/eye-open.svg",
	"./eye.svg": "./src/assets/icons/svg/eye.svg",
	"./form.svg": "./src/assets/icons/svg/form.svg",
	"./fullscreen.svg": "./src/assets/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/assets/icons/svg/guide.svg",
	"./icon.svg": "./src/assets/icons/svg/icon.svg",
	"./international.svg": "./src/assets/icons/svg/international.svg",
	"./job.svg": "./src/assets/icons/svg/job.svg",
	"./language.svg": "./src/assets/icons/svg/language.svg",
	"./link.svg": "./src/assets/icons/svg/link.svg",
	"./list.svg": "./src/assets/icons/svg/list.svg",
	"./lock.svg": "./src/assets/icons/svg/lock.svg",
	"./log.svg": "./src/assets/icons/svg/log.svg",
	"./logininfor.svg": "./src/assets/icons/svg/logininfor.svg",
	"./message.svg": "./src/assets/icons/svg/message.svg",
	"./money.svg": "./src/assets/icons/svg/money.svg",
	"./monitor.svg": "./src/assets/icons/svg/monitor.svg",
	"./nested.svg": "./src/assets/icons/svg/nested.svg",
	"./online.svg": "./src/assets/icons/svg/online.svg",
	"./password.svg": "./src/assets/icons/svg/password.svg",
	"./pdf.svg": "./src/assets/icons/svg/pdf.svg",
	"./people.svg": "./src/assets/icons/svg/people.svg",
	"./peoples.svg": "./src/assets/icons/svg/peoples.svg",
	"./phone.svg": "./src/assets/icons/svg/phone.svg",
	"./post.svg": "./src/assets/icons/svg/post.svg",
	"./qq.svg": "./src/assets/icons/svg/qq.svg",
	"./search.svg": "./src/assets/icons/svg/search.svg",
	"./server.svg": "./src/assets/icons/svg/server.svg",
	"./share_add.svg": "./src/assets/icons/svg/share_add.svg",
	"./share_user.svg": "./src/assets/icons/svg/share_user.svg",
	"./shopping.svg": "./src/assets/icons/svg/shopping.svg",
	"./size.svg": "./src/assets/icons/svg/size.svg",
	"./skill.svg": "./src/assets/icons/svg/skill.svg",
	"./star.svg": "./src/assets/icons/svg/star.svg",
	"./swagger.svg": "./src/assets/icons/svg/swagger.svg",
	"./system.svg": "./src/assets/icons/svg/system.svg",
	"./tab.svg": "./src/assets/icons/svg/tab.svg",
	"./table.svg": "./src/assets/icons/svg/table.svg",
	"./theme.svg": "./src/assets/icons/svg/theme.svg",
	"./tn-add.svg": "./src/assets/icons/svg/tn-add.svg",
	"./tn-bill.svg": "./src/assets/icons/svg/tn-bill.svg",
	"./tn-daiban.svg": "./src/assets/icons/svg/tn-daiban.svg",
	"./tn-delete.svg": "./src/assets/icons/svg/tn-delete.svg",
	"./tn-digital.svg": "./src/assets/icons/svg/tn-digital.svg",
	"./tn-down.svg": "./src/assets/icons/svg/tn-down.svg",
	"./tn-expense.svg": "./src/assets/icons/svg/tn-expense.svg",
	"./tn-fenfa.svg": "./src/assets/icons/svg/tn-fenfa.svg",
	"./tn-gas.svg": "./src/assets/icons/svg/tn-gas.svg",
	"./tn-gas2.svg": "./src/assets/icons/svg/tn-gas2.svg",
	"./tn-goback.svg": "./src/assets/icons/svg/tn-goback.svg",
	"./tn-jiantou.svg": "./src/assets/icons/svg/tn-jiantou.svg",
	"./tn-logout.svg": "./src/assets/icons/svg/tn-logout.svg",
	"./tn-mineral.svg": "./src/assets/icons/svg/tn-mineral.svg",
	"./tn-more.svg": "./src/assets/icons/svg/tn-more.svg",
	"./tn-msg.svg": "./src/assets/icons/svg/tn-msg.svg",
	"./tn-nav-annual.svg": "./src/assets/icons/svg/tn-nav-annual.svg",
	"./tn-nav-message.svg": "./src/assets/icons/svg/tn-nav-message.svg",
	"./tn-nav-producer.svg": "./src/assets/icons/svg/tn-nav-producer.svg",
	"./tn-nav-well.svg": "./src/assets/icons/svg/tn-nav-well.svg",
	"./tn-oil.svg": "./src/assets/icons/svg/tn-oil.svg",
	"./tn-oil1.svg": "./src/assets/icons/svg/tn-oil1.svg",
	"./tn-progress.svg": "./src/assets/icons/svg/tn-progress.svg",
	"./tn-readed.svg": "./src/assets/icons/svg/tn-readed.svg",
	"./tn-search.svg": "./src/assets/icons/svg/tn-search.svg",
	"./tn-shouqi.svg": "./src/assets/icons/svg/tn-shouqi.svg",
	"./tn-tat.svg": "./src/assets/icons/svg/tn-tat.svg",
	"./tn-tianjia.svg": "./src/assets/icons/svg/tn-tianjia.svg",
	"./tn-upload.svg": "./src/assets/icons/svg/tn-upload.svg",
	"./tn-volume.svg": "./src/assets/icons/svg/tn-volume.svg",
	"./tool.svg": "./src/assets/icons/svg/tool.svg",
	"./tree-table.svg": "./src/assets/icons/svg/tree-table.svg",
	"./tree.svg": "./src/assets/icons/svg/tree.svg",
	"./ts.svg": "./src/assets/icons/svg/ts.svg",
	"./user.svg": "./src/assets/icons/svg/user.svg",
	"./validCode.svg": "./src/assets/icons/svg/validCode.svg",
	"./warning.svg": "./src/assets/icons/svg/warning.svg",
	"./wechat.svg": "./src/assets/icons/svg/wechat.svg",
	"./zip.svg": "./src/assets/icons/svg/zip.svg",
	"./提醒.svg": "./src/assets/icons/svg/提醒.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";